var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPizza = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  className: "pizza_svg___icon_7rbmn_1",
  width: "1em",
  height: "1em",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "pizza_svg__Pizza pizza_svg__24"
}, /*#__PURE__*/React.createElement("g", {
  className: "pizza_svg__SVG"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFC220",
  d: "M21.653 1c.559 0 1 .462 1 1.02v19.785c0 1.54-1.667 2.502-3 1.732l-16.9-9.757c-.965-.557-1.295-1.801-.648-2.708C6.457 4.975 13.591 1 21.653 1Z",
  className: "pizza_svg__Fill-Main"
}), /*#__PURE__*/React.createElement("g", {
  className: "pizza_svg__Fill-Secondary"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFC220",
  d: "M22.653 2.02a1.01 1.01 0 0 0-1-1.02C13.591 1 6.458 4.975 2.105 11.072c-.647.907-.317 2.15.648 2.708l1.712.988C7.955 8.918 14.346 5 21.653 5c.335 0 .669.008 1 .025V2.02Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "M22.653 2.02a1.01 1.01 0 0 0-1-1.02C13.591 1 6.458 4.975 2.105 11.072c-.647.907-.317 2.15.648 2.708l1.712.988C7.955 8.918 14.346 5 21.653 5c.335 0 .669.008 1 .025V2.02Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FF6334",
  fillRule: "evenodd",
  d: "M17.153 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-5 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm10.5-.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-3.585 3.75a2.5 2.5 0 0 1 .915 3.415l-4.33-2.5a2.5 2.5 0 0 1 3.415-.915Z",
  className: "pizza_svg__Fill-Accent",
  clipRule: "evenodd"
})))));
export default SvgPizza;